export function Amount({ amount, ...options }) {
  const [integer, remainder] = formatAmount(amount, options)
  return (
    <>
      <span className="text-lg font-semibold text-white m-0">
        {integer || '---'}
      </span>
      <span className="ml-1 text-sm font-semibold text-white text-opacity-40">
        {remainder || '---'}
      </span>
    </>
  )
}

function formatAmount(amount, { precision = 0 } = {}) {
  if (amount !== undefined) {
    const [integer, remainder] = (amount / 1000).toFixed(3).split('.')
    if (precision == 0) {
      return [integer, "K"]
    } else {
      const extraPrecision = remainder.toString().slice(0, precision)
      return [integer + "." + extraPrecision, "K"]
    }
  }
  return [null, "K"];
};